'use client';
import React from 'react';
import { Heading, PlanCard, PlanFeatures, Price, PriceContainer, Text, Title } from '../styled';
import { LK } from '@/consts';

export const FreePlan = () => {
  return (
    <PlanCard>
      <Title>Free Plan</Title>
      <div>
        <Heading>Ideal for:</Heading>
        <Text>
          Micro-businesses and sole traders in the UAE with annual revenue below AED 200,000 and
          fewer than 120 invoices per year
        </Text>
      </div>

      <div>
        <Heading>Features:</Heading>
        <PlanFeatures>
          <Text>Up to 120 invoices per year</Text>
          <Text>VAT calculation at 5% UAE standard rate</Text>
          <Text>Basic bank statement import (PDF)</Text>
          <Text>P&L and basic financial reports</Text>
          <Text>EmaraTax form generation</Text>
        </PlanFeatures>
      </div>

      <div className="flex-grow" />
      <PriceContainer>
        <Price>
          <Title style={{ fontSize: 36, color: '#217442' }}>AED 0</Title>
        </Price>
      </PriceContainer>
      <a href={LK}>
        <button className="w-full transition hover:bg-gradient-white bg-gradient-custom hover:text-black text-white rounded-full text-center px-6 py-3 text-nowrap">
          Get started free
        </button>
      </a>
    </PlanCard>
  );
};
